export default "__VITE_ASSET__QtHzqnkf__"